<template>
  <div class="ui form segment" id="new-default-package-step">
    <div class="field">
      <label>Description</label>
      <textarea rows="3"
                :placeholder="'Description'"
                v-model="default_package.description"
                name="description"></textarea>
    </div>

    <div class="field">
      <label for="name">Quantity</label>
      <div class="ui input">
        <input type="number"
               v-model="default_package.quantity"
               :placeholder="'Quantity'"
               name="quantity">
      </div>
    </div>

    <div class="two fields">
      <div class="field">
        <label for="start_at">Start At</label>
        <div style="text-align: center" class="ui calendar" :id="'start-at'">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text"
                   :placeholder="'Start At'"
                   readonly=""
                   name="day">
          </div>
        </div>
      </div>

      <div class="field">
        <label for="chooseMaritalStatus">unit measurement</label>
        <select class="ui fluid search dropdown"
                id="unit-measurment-id"
                v-model="default_package.unit_measurement_id"
                name="unitMeasurement">
          <option value="">Unit measurement</option>
          <option :value="1">Pulse</option>
          <option :value="2">MiliGram</option>
          <option :value="3">Visit</option>
        </select>
      </div>
    </div>

    <div class="field">
      <label for="critical_diseases">Medical Machines</label>
      <select name="medicalMachines" multiple="[]" class="ui fluid dropdown" id="multi-select"
              v-model="default_package.medical_machines">
        <!-- <option value="">{{ $t('criticalDiseases') }}</option> -->
        <option value="">Medical Machines</option>
        <option :value="1">Pulse</option>
        <option :value="2">MiliGram</option>
        <option :value="3">Visit</option>
        <!-- <option :value="criticalDisease.id" v-for="criticalDisease in criticalDiseases">
          {{ criticalDisease.name }}
        </option> -->
      </select>
    </div>

    <br/>
    <div class="ui blue left labeled icon button" style="background-color: #092442" @click="perivous()">
      <i class="left arrow icon"></i>
      Perivous
    </div>

    <div class="ui blue right floated right labeled icon button"
         style="background-color: #092442"
         @click="next()">
      <i class="right arrow icon"></i>
      Next
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      default_package: {
        quantity: null,
        unit_measurement_id: null,
        start_at: null,
        description: '',
        medical_machines: []
      }
    }
  },
  mounted () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#start-at').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.default_package.start_at = date
          }
        })

        $('#unit-measurment-id').dropdown()
        $('#multi-select').dropdown()

        $('#new-default-package-step').form({
          inline: true,
          on: 'blur',
          fields: {
            description: {
              identifier: 'description',
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Enter a description for your the default package.'
                }
              ]
            },
            quantity: {
              identifier: 'quantity',
              rules: [
                {
                  type: 'number',
                  prompt: 'Please, Enter a the quantity for price.'
                }
              ]
            },
            unitMeasurement: {
              identifier: 'unitMeasurement',
              rules: [
                {
                  type: 'integer',
                  prompt: 'Please, Choose a valid unit measurement.'
                }
              ]
            }
          }
        })
      })
    },
    next () {
      this.$emit('reservationType-step2Changes', {
        data: {
          defaultPackageInfo: this.default_package,
          next: $('#new-default-package-step').form('is valid')
        }
      })
    },
    perivous () {
      this.$emit('reservationType-goToStepOne')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/steps/reservation_types/new_reservation_type_steps/DefaultPackageInfoStep.vue